import React from 'react'
import img2 from '../../assests/imgs/gotMessage.svg'

const Success = () => {
    return (
        <div>
            <img src={img2} alt='recieved message'
            className='form-img-2' />
        </div>
    )
}

export default Success;
